import React from "react";
import { Typography, Box, Paper, IconButton } from "@mui/material";

import LinkedInIcon from "@mui/icons-material/LinkedIn";
import TwitterIcon from "@mui/icons-material/Twitter";
import "../../style/global.scss";
import "../../style/speaker.scss";

import mslogo from "../../assets/logoIcons/ms.png";
import mvpLogo from "../../assets/logoIcons/mvp.jpg";
import { BorderAllRounded } from "@mui/icons-material";

const Card = ({
  theme,
  image,
  name,
  designation,
  company,
  linkedIn,
  twitter,
  mvp,
  isMicroSoftEmployee,
}) => {
  const styles = {
    card: {
      maxWidth: "40rem",
      backgroundColor: "#0F695C",
      borderRadius: "2rem",

      textAlign: "center",
      color: "#fff",
      boxShadow: "0 0 20px rgba(0, 0, 0, 0.2)",
      paddingBottom: "1rem",
      fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
    },
    titleContainer: {
      backgroundColor: "#0F695C",
      borderRadius: "2rem",
      padding: "2rem 0 1rem",
      // position: "relative",
      display: "flex",
      justifyContent: "center",
      textAlign: "center",
    },
    profileImg: {
      width: "20rem",
      height: "20rem",
      borderRadius: "50%",
      marginTop: "-50%",
      objectFit: "cover",
      border: "1.2rem solid rgba(10, 75, 72, 0.27)",
      boxShadow: "0 4px 10px rgba(0, 0, 0, 0.4)",
    },
    name: {
      fontSize: "2.2rem",
      fontWeight: "bold",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      gap: "0.5rem",
      margin: "1rem 0 0.2rem",
    },
    logo: {
      width: "2rem",
      height: "2rem",
    },
    subtitle: {
      fontSize: "1.6rem",
      color: "#d0d0d0",
      marginBottom: "1rem",
    },
    social: {
      display: "flex",
      justifyContent: "center",
      gap: "2rem",
    },
    icon: {
      fontSize: "2.5rem",
      color: "#fff",
      cursor: "pointer",
      transition: "color 0.3s",
    },
  };

  return (
    <div className="card">
      <img className="img" src={image} alt={name} loading="lazy" width="100%" />
      <div className="text">
        <div className="speakerName">
          {name}
          {isMicroSoftEmployee && (
            <IconButton href={""} target="_blank" aria-label="MVP" disabled>
              <img
                src={mslogo}
                style={{ width: "4rem" }}
                className="card-social-img"
                alt="microsoft"
              />
            </IconButton>
          )}
        </div>
        <div className="designation">
          {designation} , {company}
        </div>
      </div>
      <div className="social-icons">
        <IconButton href={linkedIn} aria-label="LinkedIn" target="_blank">
          <TwitterIcon
            style={{
              color: "#fff",
              width: "3.6rem ",
              height: "3.6rem",
              marginRight: "2rem",
            }}
          />
        </IconButton>
        <IconButton href={linkedIn} aria-label="LinkedIn" target="_blank">
          <LinkedInIcon
            style={{
              color: "#fff",
              width: "3.6rem ",
              height: "3.6rem",
            }}
          />
        </IconButton>
        {mvp && (
          <IconButton href={""} target="_blank" aria-label="MVP" disabled>
            <img
              src={mvpLogo}
              className="card-social-img"
              alt="microsoft-mvp"
            />
          </IconButton>
        )}
      </div>
    </div>
  );

  return (
    <div style={styles.card}>
      <div style={styles.titleContainer}>
        <img src={image} alt="Profile" style={styles.profileImg} />
      </div>
      <div style={{ padding: "3rem" }}>
        <h2 style={styles.name}>
          {name}
          {mvp && (
            <IconButton href={""} target="_blank" aria-label="MVP" disabled>
              <img
                src={mvpLogo}
                className="card-social-img"
                alt="microsoft-mvp"
              />
            </IconButton>
          )}
        </h2>
        <p style={styles.subtitle}>
          {designation} , {company}
        </p>
      </div>
      <div style={styles.social}>
        {linkedIn && (
          <IconButton href={linkedIn} aria-label="LinkedIn" target="_blank">
            <LinkedInIcon color="primary" className="card-social-icon" />
          </IconButton>
        )}
        {twitter && (
          <IconButton href={twitter} aria-label="twitter" target="_blank">
            <TwitterIcon
              sx={{
                color: theme.icon.twitter,
              }}
              className="card-social-icon"
            />
          </IconButton>
        )}
      </div>
    </div>
  );
  return (
    <>
      <Box className="card pointer">
        <Paper elevation={3} className="card-paper">
          <Box className="img-wrapper">
            <img src={image} alt={name} loading="lazy" width="100%" />
          </Box>
          <Box className="card-content">
            <Box className="card-title-container d-flex justify-content-center align-items-center text-center">
              <Typography className="card-title text-uppercase">
                {name}
              </Typography>
            </Box>
            <Box className="card-container">
              <Typography className="card-subtitle text-left">
                {designation}
              </Typography>
              <Typography
                className="card-subtitle text-left"
                sx={{
                  fontWeight: "600",
                }}
              >
                {company}
              </Typography>
            </Box>
            <Box className="card-social text-left">
              {mvp && (
                <IconButton href={""} target="_blank" aria-label="MVP" disabled>
                  <img
                    src={mvpLogo}
                    className="card-social-img"
                    alt="microsoft-mvp"
                  />
                </IconButton>
              )}
              {isMicroSoftEmployee && (
                <IconButton href={""} target="_blank" aria-label="MVP" disabled>
                  <img
                    src={mslogo}
                    className="card-social-img"
                    alt="microsoft"
                  />
                </IconButton>
              )}

              {linkedIn && (
                <IconButton
                  href={linkedIn}
                  aria-label="LinkedIn"
                  target="_blank"
                >
                  <LinkedInIcon color="primary" className="card-social-icon" />
                </IconButton>
              )}
              {twitter && (
                <IconButton href={twitter} aria-label="twitter" target="_blank">
                  <TwitterIcon
                    sx={{
                      color: theme.icon.twitter,
                    }}
                    className="card-social-icon"
                  />
                </IconButton>
              )}
            </Box>
          </Box>
        </Paper>
      </Box>
    </>
  );
};
export default Card;
